import Login, { AppLogin } from "../screens/Login";
import Applications from "../screens/Applications";
import Demo from '../components/Demo';
import Verify from '../components/Verify';
import { AppRegister } from '../screens/Register';
import Incription from '../screens/Incription';
import ProxyView from "../screens/Proxy/View";
import ProxyEdit from "../screens/Proxy/Edit";
import Invitation from '../components/Invitation';
import ProxyViewCADD from "../screens/Proxy/Viewdd";
import ProxyEditCADD from "../screens/Proxy/Editdd";
import ResetPassword from '../screens/ResetPassword';
import ProxyAnalysis from '../screens/Proxy/Analysis';
import HomePage from "../screens/HomePage";
import AppInvitation from "../screens/AppInvitation";
import AppRedirect from "../screens/AppRedirect";

const publicRoutes = [
  {
    path: "/",
    key: "APPLICATIONS",
    exact: true,
    component: process.env.REACT_APP_APP ? <HomePage /> : <Applications />,
  },
  {
    path: "/login",
    key: "LOGIN",
    exact: true,
    component: <Login />
  },
  {
    path: "/:app/app-invitation",
    key: "APP_INVITATION",
    exact: true,
    component: <AppInvitation />
  },
  {
    path: "/app-redirect",
    key: "APP_REDIRECT",
    exact: true,
    component: <AppRedirect />
  },
  {
    path: "/admin/login",
    key: "ADMIN_LOGIN",
    exact: true,
    component: <Login app="admin" />
  },
  {
    path: "/:app",
    key: "TIF",
    exact: true,
    component: <AppLogin />
  },
  {
    path: "/:app/login",
    key: "TIF_LOGIN",
    exact: true,
    component: <AppLogin />
  },
  {
    path: "/:app/register",
    key: "APP_REGISTER",
    exact: true,
    component: <AppRegister />,
  },
  {
    path: "/register",
    key: "REGISTER",
    exact: true,
    component: <AppRegister />
  },
  {
    path: "/inscription",
    key: "INSRIPTION",
    exact: true,
    component: <Incription />,
  },
  {
    path: "/:app/:language",
    key: "APP_REGISTER_LANG",
    exact: true,
    component: <AppRegister />
  },
  {
    path: "/v",
    key: "VERIFY",
    exact: true,
    component: <Verify />
  },
  {
    path: "/:app/v",
    key: "VERIFY_APP",
    exact: true,
    component: <Verify />
  },
  {
    path: '/r/:companyCode/:userCode',
    key: "INVITATION",
    exact: true,
    component: <Invitation />
  },
  {
    path: '/:app/r/:companyCode/:userCode',
    key: "APP_INVITATION",
    exact: true,
    component: <Invitation />
  },
  {
    path: '/demo/:code',
    key: "DEMO",
    exact: true,
    component: <Demo />,
  },
  {
    path: "/password/reset",
    key: "RESET_PASSWORD",
    exact: true,
    component: <ResetPassword />,
  },
  {
    path: "/password/reset/:confirmation",
    key: "RESET_PASSWORD_CONFIRMATION",
    exact: true,
    component: <ResetPassword />,
  },
  {
    path: "/:app/password/reset",
    key: "RESET_PASSWORD",
    exact: true,
    component: <ResetPassword />,
  },
  {
    path: "/:app/password/reset/:confirmation",
    key: "RESET_PASSWORD_CONFIRMATION",
    exact: true,
    component: <ResetPassword />,
  },
  {
    path: '/proxy/pme/analysis/:namespace/:id/:sourceId?',
    key: 'PROXY_ANALYSIS',
    component: <ProxyAnalysis />,
    hideSource: true,
    exact: true,
    visible: () => {
      return true;
    },
  },
  {
    path: '/proxy/cadd/analysis/:namespace/:id/:sourceId?',
    key: 'PROXY_CADD_ANALYSIS',
    component: <ProxyAnalysis />,
    hideSource: true,
    exact: true,
    visible: () => {
      return true;
    },
  },
  {
    path: '/proxy/pme/view/:namespace/:id/:group?/:subsection?/:subgroup?',
    key: 'PROXY_VIEW',
    component: <ProxyView />,
    hideSource: true,
    exact: true,
    visible: () => {
      return true;
    },
  },
  {
    path: '/proxy/cadd/view/:namespace/:id/:group?/:subsection?/:subgroup?',
    key: 'PROXY_CADD_VIEW',
    component: <ProxyView />,
    hideSource: true,
    exact: true,
    visible: () => {
      return true;
    },
  },
  {
    path: '/proxy/pme/viewdd/:namespace/:id/:group?/:subsection?/:subgroup?',
    key: 'PROXY_VIEW_DD',
    component: <ProxyViewCADD />,
    hideSource: true,
    exact: true,
    visible: () => {
      return true;
    },
  },
  {
    path: '/proxy/cadd/viewdd/:namespace/:id/:group?/:subsection?/:subgroup?',
    key: 'PROXY_VIEW_DD_CADD',
    component: <ProxyViewCADD />,
    hideSource: true,
    exact: true,
    visible: () => {
      return true;
    },
  },
  {
    path: '/proxy/pme/edit/:namespace/:id/:group?/:subsection?/:subgroup?/:formid?',
    key: 'PROXY_PME_EDIT',
    component: <ProxyEdit />,
    hideSource: true,
    exact: true,
    visible: () => {
      return true;
    },
  },
  {
    path: '/proxy/pme/editdd/:namespace/:id/:group?/:subsection?/:subgroup?/:formid?',
    key: 'PROXY_PME_EDIT_DD',
    component: <ProxyEditCADD />,
    hideSource: true,
    exact: true,
    visible: () => {
      return true;
    },
  },
  {
    path: '/proxy/cadd/edit/:namespace/:id/:group?/:subsection?/:subgroup?/:formid?',
    key: 'PROXY_CADD_EDIT',
    component: <ProxyEdit />,
    hideSource: true,
    exact: true,
    visible: () => {
      return true;
    },
  },
  {
    path: '/proxy/cadd/editdd/:namespace/:id/:group?/:subsection?/:subgroup?/:formid?',
    key: 'PROXY_CADD_EDIT_DD',
    component: <ProxyEditCADD />,
    hideSource: true,
    exact: true,
    visible: () => {
      return true;
    },
  },
];

export default publicRoutes;
